export default {
  BASE_URL: '/crmMember',
  api: [
    {
      name: 'register',
      method: 'POST',
      desc: '注册接口',
      path: '/registered',
      params: {
        accountName: 'admin',
        mobile: 'admin',
        smsCode: '',
        accountPwd: '',
        pwdLevel: 1
      }
    },
    {
      name: 'checkVcode4reg',
      method: 'POST',
      desc: '注册校验验证码',
      path: '/regSmsVerCode',
      params: {}
    },
    {
      name: 'mobileIsExist',
      method: 'GET',
      desc: '手机号是否存在',
      path: '/mobileIsExist',
      append: true,
      params: {}
    },
    {
      name: 'userIsExist',
      method: 'POST',
      desc: '用户名是否存在',
      path: '/userIsExist',
      params: {}
    },
    {
      name: 'resetPwd',
      method: 'PUT',
      desc: '忘记密码',
      path: '/resetPwd',
      params: {}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/member.js